module.exports = __webpack_public_path__ + "static/img/k24_kw_03.8b270fbc.png";